// const HOSTNAME = "http://localhost:80";
const HOSTNAME = "https://stagging-backend-api.kartblock.com";
export {HOSTNAME}